import { Amplify, Auth, Hub } from 'aws-amplify';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Dispatch } from 'redux';
import App from './App';
import { AssignOrderAction, ClearUserLoginJWTToken, GetActiveSubcriptionDataAction, SaveUserLoginCookiesAction, SetRecentlyConfirmed, SetUser, StoreAction } from './app/ActionsImpl';
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import store from './app/store';
import { COOKIE_STORAGE, GOOGLE_TAG_MANAGER_ID, __DEV__ } from './constants';
import { translations } from './utils/LocalizedStrings';

console.log('%c STOP! ', 'background: #222; color: red; font-size: 30px');
console.log('%c Toto je funkcia prehliadača určená pre vývojárov. Ak vám niekto povedal, aby ste sem niečo vložili a aktivovali tak nejakú funkciu MOJEZMLUVY.SK alebo prelomili zabezpečenie , ide o podvod, vďaka ktorému môže dotyčný získať prístup k vašim informáciám. ', 'background: #222; color: white;');

const cookieStorage = {
    domain: __DEV__ ? window.document.location.hostname : COOKIE_STORAGE,
    secure: !__DEV__,
    path: '/',
    expires: 365,
};

const otherSites: { [Key: string]: string } = {
    // ".amplifyapp.com": 'https://main.dlvz2t3fd3adw.amplifyapp.com/resolve-login'
    // ".orsr.help": 'https://develop.app.orsr.help/resolve-login'
}

Amplify.configure({
    Auth: {
        identityPoolId: 'eu-central-1:d7fbb443-edc1-403e-bff6-c106b584620a', //REQUIRED - Amazon Cognito Identity Pool ID
        region: 'eu-central-1',
        userPoolId: 'eu-central-1_sbixGAMgk', //OPTIONAL - Amazon Cognito User Pool ID
        userPoolWebClientId: '1ld8fmnuiv9lusddkg3iqb8vcn', //OPTIONAL - Amazon Cognito Web Client ID
    },
    cookieStorage
});


const tagManagerArgs = {
    gtmId: GOOGLE_TAG_MANAGER_ID!
};

TagManager.initialize(tagManagerArgs)

axios.interceptors.request.use(
    config => {
        if (store.getState().appState.cognitoUser) {
            return Auth.currentSession().then(session => {
                const jwtToken = session.getAccessToken().getJwtToken()
                config.headers.Authorization = jwtToken
                return config
            })
        } else {
            return config
        }
    },
    error => Promise.reject(error)
);

Amplify.register(Auth)

const getCookiesStartingWith = (prefix: any) => {
    const cookies = document.cookie.split('; ');
    const result: any = {};

    for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name.startsWith(prefix)) {
            result[name] = value;
        }
    }

    return result;
};

export interface Props extends StateProps, DispatchProps { }

const AuthStateApp = (props: Props) => {

    const [logout, setLogout] = useState(false)
    const [openedSites, setOpenedSites] = useState<{ [Key: string]: string }>({})
    const [finishedOrigins, setFinishedOrigins] = useState<any[]>([])
    const iframeRef = useRef<(HTMLDivElement | null)[]>([]);

    React.useEffect(() => {
        console.log(props.language)
        translations.setLanguage(props.language)
    }, [props.language])

    React.useEffect(() => {
        props.SetUser()
        const listener = async (data: any) => {
            switch (data.payload.event) {
                case "signIn": {
                    await props.SetUser()
                    const cookieName = 'CognitoIdentityServiceProvider';
                    const cookieValue = getCookiesStartingWith(cookieName);
                    // props.SaveUserLoginCookies(cookieValue)
                    let domain = __DEV__ ? window.document.location.hostname : COOKIE_STORAGE
                    // for (const [name, value] of Object.entries(cookieValue)) {
                    //     if (name.startsWith('CognitoIdentityServiceProvider')) {
                    //         document.cookie = `${name}=${value}; domain=${domain}; SameSite=None; path=/; Secure`;
                    //         console.log(name, value)
                    //     }
                    // }
                    // setOpenedSites(otherSites)
                    break
                }
                case "signOut": {
                    props.SetUser()
                    setOpenedSites(otherSites)
                    setLogout(true)
                    console.log("logout")
                    break
                }
            }
        }
        const removeHub = Hub.listen("auth", listener)
        return () => removeHub()
    }, []);

    useEffect(() => {
        const handleMessage = (event: any) => {
            if (event && event.data && event.data.action === 'LOGIN_FINISHED') {
                let newFinishedOrigins = JSON.parse(JSON.stringify(finishedOrigins))
                newFinishedOrigins.push(event.data.origin)
                setFinishedOrigins(newFinishedOrigins)
            }
        };
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };

    }, []);

    useEffect(() => {
        if (finishedOrigins.length > 0 && finishedOrigins.length === Object.keys(openedSites).length) {
            setOpenedSites({})
            setLogout(false)
            setFinishedOrigins([])
            props.ClearToken()
        }

    }, [finishedOrigins]);


    React.useEffect(() => {
        iframeRef.current.forEach((ref, index) => {
            const iframe = ref as any;
            console.log(ref)
            if (iframe && props.cookieShareJWTToken) {
                iframe.addEventListener("load", function () {
                    console.log("iframe loaded")
                    iframe.contentWindow.postMessage({ token: props.cookieShareJWTToken, action: "resolve-login" }, iframe.src);
                });
            }
        })
    }, [props.cookieShareJWTToken]);

    React.useEffect(() => {
        iframeRef.current.forEach((ref, index) => {
            const iframe = ref as any;
            if (iframe && logout) {
                iframe.addEventListener("load", function () {
                    console.log("iframe loaded")
                    iframe.contentWindow.postMessage({ action: "resolve-logout" }, iframe.src);
                });
            }
        })
    }, [logout]);

    React.useEffect(() => {
        if (props.recentlyConfirmed) {
            props.AssignOrder(props.user.attributes.email)
            SetRecentlyConfirmed(false)
        }
        if (props.user) {
            props.GetActiveSubscription()
        }
    }, [props.user])

    return <>
        <App />
        {(props.cookieShareJWTToken || logout) &&
            Object.entries(openedSites).map(([key, site], index) => {
                return (
                    <iframe
                        key={key}
                        style={{ display: "none" }}
                        ref={(el) => (iframeRef.current[index] = el)}
                        src={site}
                        title="Login iframe"
                    ></iframe>
                )
            })
        }
    </>

}



const mapStateToProps = ({ appState }: any) => ({
    language: appState.language,
    recentlyConfirmed: appState.recentlyConfirmed,
    user: appState.cognitoUser,
    cookieShareJWTToken: appState.cookieShareJWTToken
});

type StateProps = ReturnType<typeof mapStateToProps>;
export interface DispatchProps {
    SetUser: () => void;
    GetActiveSubscription: () => void;
    AssignOrder: (email: string) => void;
    SetRecentlyConfirmed: (confirmed: boolean) => void;
    SaveUserLoginCookies: (data: any) => void;
    ClearToken: () => void;
}

function mapDispatchToProps(dispatch: Dispatch<StoreAction, any>): DispatchProps {
    return {
        SetUser: () => dispatch(SetUser()),
        GetActiveSubscription: () => dispatch(GetActiveSubcriptionDataAction()),
        AssignOrder: (email) => dispatch(AssignOrderAction(email)),
        SetRecentlyConfirmed: (confirmed: boolean) => dispatch(SetRecentlyConfirmed(confirmed)),
        SaveUserLoginCookies: (data: any) => dispatch(SaveUserLoginCookiesAction(data)),
        ClearToken: () => dispatch(ClearUserLoginJWTToken())
    };

}

export default connect(mapStateToProps, mapDispatchToProps)(AuthStateApp)